/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IRegionSelectorViewProps } from './region-selector';

export default (props: IRegionSelectorViewProps) => {
    const { destinationUrl, useQueryParameter, queryParameter, checkFlag, regions } = props.config;
    const { regionSelectorHeading } = props.resources;

    let query_param = 'true'; // Default value
    if (useQueryParameter && queryParameter) {
        query_param = (props.context.request.query as Object)[queryParameter];
    }
    const active_flag = props.context.request.query?.flag ? true : false;

    return (
        <div className='region-selector'>
            <div className='row'>
                <h4>{regionSelectorHeading}</h4>
            </div>
            <div className='row justify-content-center'>
                {regions?.map(region => (
                    // eslint-disable-next-line react/jsx-key
                    <div
                        className='col-6 col-sm-4 col-md-3 col-lg-2'
                        onClick={() => {
                            if (typeof window !== undefined && region.url !== undefined) {
                                let destination_chain = `https://${region.url}/${destinationUrl}`;
                                if (useQueryParameter) {
                                    destination_chain += `?${queryParameter}=${query_param}`;
                                    if (checkFlag) {
                                        destination_chain += `&flag=${active_flag}`;
                                    }
                                } else {
                                    if (checkFlag) {
                                        destination_chain += `?flag=${active_flag}`;
                                    }
                                }
                                window.location.href = destination_chain;
                            }
                        }}
                    >
                        <div className='region-tile'>
                            <img src={region.image?.src} alt={region.displayString} className='region-tile-img' />
                            <p className='region-tile-language'>{region.displayString}</p>
                            <p className='region-tile-region'>{region.displaySubString}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
